import { UserRound } from "lucide-react";
import SectionHeading, { Reveal } from "@/components/SectionHeading";

export default function Trainers() {
  return (
    <section id="trainers" data-testid="trainers-section" className="bg-[#1A1A1A] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow="Our Trainers"
          title="Train With"
          accent="The Best"
        />
        <Reveal>
          <div
            data-testid="trainers-coming-soon"
            className="max-w-2xl mx-auto bg-[#141414] border border-dashed border-[#FF5A1F]/50 rounded-xl px-8 py-14 text-center"
          >
            <span className="mx-auto w-14 h-14 rounded-full bg-[#FF5A1F]/15 border border-[#FF5A1F]/40 flex items-center justify-center">
              <UserRound className="w-7 h-7 text-[#FF5A1F]" />
            </span>
            <h3 className="mt-5 font-heading text-3xl tracking-wider text-white uppercase">
              Trainer Profiles Coming Soon
            </h3>
            <p className="mt-3 text-sm sm:text-base leading-relaxed text-[#D1D1D1]">
              We're putting together our coaching team's profiles. Real trainer photos,
              specializations and experience details will be added here shortly.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
